import { createRouter, createWebHistory } from "vue-router";
import EventList from "../views/EventList.vue";
import EventDetails from "../views/EventDetails.vue";
import About from "../views/About.vue";

const routes = [
  {
    path: "/",
    name: "EventList",
    component: EventList
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting == performance optimization
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/About.vue")
    component: About
  },
  {
    path: '/event/:id',
    name: 'EventDetails',
    props: true,  // params can be given to a router-link
    component: EventDetails
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
